/**
 * Get the selected text displaying type from the store
 * @param state The entire redux store
 * @returns
 */
export const getCustomTextDisplayType = (state): string => {
  if (!state.configurator.configuration) return "";

  const selectedoptions =
    state.configurator.configuration.optionclassifications.find(
      (item) => item.identifier === "bestickung"
    )?.selectedoptions;

  return !!selectedoptions ? selectedoptions[0].identifier : null;
};

/**
 * Gets all unique category type they are appearing in option's attributes
 * @param options Option list of the selected optionclassification
 * @returns
 */
export const getOptionCategories = (options: any[] = []) => {
  let filterCollection = [];

  options.forEach((option) => {
    const values =
      option.attributes.find((attr) => attr.identifier === "filter")?.values ||
      [];

    filterCollection = [...filterCollection, ...values];
  });

  return filterCollection.filter(
    // Return only the unique utems
    (item, index, self) => {
      return self.findIndex((jtem) => jtem.id === item.id) === index;
    }
  );
};
